import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, map, tap } from 'rxjs';
import { AuthService } from '@app/core/services/auth.service';
import { IAuthUser } from '@app/core/api/auth/auth.interface';
import { getRoleHomePath } from '@app/core/routing/role-home';

@Injectable({
  providedIn: 'root',
})
export class RootRedirectGuard {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

    /**
   * V2 Guard
   * This guard checks if the user is logged in and redirects to the appropriate page
   * @param route 
   * @param state 
   * @returns 
   */

  canActivate(): Observable<boolean> {
    return this.authService.currentUser$.pipe(
      tap((user: IAuthUser | null) => {
        if (!user) {
          this.router.navigate(['/auth/login']);
          return;
        }
        
        if (user.type) {
          void this.router.navigateByUrl(getRoleHomePath(user.type));
        }
      }),
      map(() => false) // Always return false as we always want to redirect
    );
  }
} 